import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
import "./index.scss";
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import headerImg from "./assets/key-art_Desktop.png";
import headerImgMb from "./assets/key-art_mobile.jpg";
import aboutImg from "./assets/about.png";


//TODO: EVENT_ID
const EVENT_ID = "m0004";

//TODO: aboutWalkContent
const aboutWalkContent = `葫蘆墩圳引大甲溪水以人工水道，將珍貴的灌溉水源引至每吋農地，乾淨水源與適宜的條件，加上勤勞樸實的人民，發展出此地特別的文化與風情。歷史更迭中，不變的是年年如期而至的圳水，漫漫淹沒田地照顧每位大地的子民。飲水思源、拋磚引玉，願這分美好獻給所有關心豐原成長史的讀者，珍愛中實現家鄉的繁榮與進步。`;

//TODO: credit
const credit = `
<div>
    團隊介紹：臺中市后豐社區大學(朝陽科技大學承辦)，聯絡電話(04)25230460<br>
    <br>
    <br>
    本圖臺是由臺中市后豐社區大學(朝陽科技大學承辦)及智紳數位文化有限公司共同協力建置：
    <br>1. 圖臺內容：臺中市后豐社區大學
    <br>2. 圖臺系統開發：智紳數位文化事業有限公司
    <br>
    <br>除另有聲明外，本網站內容採用創用 CC 姓名標示-非商業性-相同方式分享4.0授權條款授權公眾使用，您可以依授權條款複製、引用、轉載，唯請於合理位置標示本校網址：臺中市后豐社區大學<a href="https://hf.cyut.edu.tw" target=_blank>https://hf.cyut.edu.tw</a>
    <br>本計劃由「臺中市113年度促進社區大學發展在地特色課程實施計畫」補助辦理
</div>
`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "",
  sidebarSubtitle: "",
  aboutWalkImgSrc: aboutImg,
  aboutWalkContent,
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: headerImgMb,
  headerDImgSrc: headerImg,
  menuSwitchItems: [{ id: "數位集章", name: "數位集章" }],
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [
      { county: "臺中市", town: "豐原區" },
      { county: "臺中市", town: "東勢區" },
      { county: "臺中市", town: "石岡區" },
    ], //TODO: weather 氣象預測地點
  },
  themeConfig: {
    "--dui-primary": "#459AF8", //TODO: theme
    "--dui-accent": "#8F4A91", //TODO: 數位集章按鈕顏色, more按鈕
    "--dui-secondary": "#459AF8", //TODO: theme
    "--dui-bg-secondary": "#ffc361", // Dialog background
    "--dui-bg-accent": "#85A8A8", //TODO: background
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};
// #e4e7cb
// 景點的 icon、點擊開集章卡片、cluster、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);

  useEffect(() => {
    (window as any).JSDC = Jsdc;
  }, [Jsdc]);
  return (
    <div className="root">
      <DguideWalksApp
      language="zh-TW"
      //! 左側數位集章選項
      // mainMenuChildren={
      //   <MenuItemWithDialog
      //     Icon={Checkin}
      //     title="路線顏色"
      //     active={dui.activeMenuId === '數位集章'}
      //     {...dui.menuSwitcherAction('數位集章')}
      //   >
      //     {/* {dui.activeMenuId === '數位集章' && (
      //       <iframe
      //         style={{ height: '100%', border: 0, borderRadius: '5px' }}
      //         src={`https://map.jsdc.com.tw/tools/checkin/${EVENT_ID}/showlist.php?a=${EVENT_ID}`}
      //       ></iframe>
      //     )} */}
      //     //? 設定線條顏色
      //     {paths.map(path => (
      //       <div
      //         key={path.name}
      //         style={{
      //           display: 'flex',
      //           alignItems: 'center',
      //           margin: '20px',
      //         }}
      //       >
      //         <div
      //           style={{
      //             width: '50px',
      //             height: '5px',
      //             backgroundColor: path.color,
      //             alignItems: 'center',
      //             marginRight: '10px',
      //           }}
      //         ></div>
      //         <span
      //           style={{
      //             fontSize: '20px',
      //             color: '#000',
      //             // fontWeight: "bold",
      //           }}
      //         >{` ：${path.name}`}</span>
      //       </div>
      //     ))}
      //   </MenuItemWithDialog>
      // }
      />
    </div>
  );
}

const config = new ConfigProvider({ eventId: EVENT_ID });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      bound: latLngBounds(
        //TODO: map view bound
        latLng(24.28776153365666, 120.69063126867195),
        latLng(24.212791342531784, 120.77835022632073),
      ),
      maxZoom: 19,
    }),
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider
        Jsdc={Jsdc}
        config={config}
      >
        <DuiContextProvider {...duiConfigProps}>
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
